import { $ } from '@zeus/index'
import { typedGql } from '@zeus/typedDocumentNode'
import { scalars } from '~/gql/utils/scalars'

const moduleFields = {
  id: true,
  title: true,
  scormVersion: true,
  launchUrl: true,
  status: true,
} as const

const sessionFields = {
  id: true,
  name: true,
  status: true,
  startDate: true,
  endDate: true,
  progressionMode: true,
  // ⚠️ Le PREMIER module du parcours, le temps que les derniers écrans passent
  // à `modules`. Ne pas s'appuyer dessus dans du code neuf.
  module: moduleFields,
  modules: {
    id: true,
    position: true,
    unlockAt: true,
    unlocked: true,
    lockReason: true,
    module: moduleFields,
  },
  enrolledUsers: {
    id: true,
    email: true,
    firstName: true,
    lastName: true,
  },
} as const

const trackingFields = {
  completionStatus: true,
  successStatus: true,
  scoreRaw: true,
  scoreMax: true,
  completedAt: true,
} as const

/**
 * Vue portant sur UN apprenant : à `sessionFields` s'ajoutent l'avancement du
 * parcours et, sur chaque module, son état d'ouverture et la progression.
 *
 * Ces champs sont nuls dans la vue admin (`sessions`), qui ne vise personne en
 * particulier — d'où la sélection séparée plutôt qu'un `sessionFields` gonflé
 * de champs toujours vides pour la moitié des appelants.
 */
const learnerSessionFields = {
  ...sessionFields,
  modules: {
    ...sessionFields.modules,
    myTracking: trackingFields,
  },
  progress: {
    totalModules: true,
    completedModules: true,
    completed: true,
  },
  myTracking: trackingFields,
} as const

export const GQL_SESSIONS = typedGql('query', { scalars })({
  sessions: sessionFields,
})

export const GQL_MY_SESSIONS = typedGql('query', { scalars })({
  mySessions: learnerSessionFields,
})

export const GQL_USER_SESSIONS = typedGql('query', { scalars })({
  userSessions: [{ userId: $('userId', 'ID!') }, learnerSessionFields],
})

export const GQL_CREATE_SESSION = typedGql('mutation', { scalars })({
  createSession: [{ input: $('input', 'CreateSessionInput!') }, sessionFields],
})

export const GQL_UPDATE_SESSION = typedGql('mutation', { scalars })({
  updateSession: [
    { id: $('id', 'ID!'), input: $('input', 'UpdateSessionInput!') },
    sessionFields,
  ],
})

export const GQL_DELETE_SESSION = typedGql('mutation')({
  deleteSession: [{ id: $('id', 'ID!') }, true],
})
